module.exports = __webpack_public_path__ + "static/media/singer.57b85f04.jpg";